import type { FC } from "react";
import type { Exam } from "../../api/dto";
import type { Inspection } from "../../api/dto/Inspection";
import { Badge, BadgeStyle } from "./Badge";

type ExamStatus = Exam["status"];
type InspectionStatus = Inspection["status"];
export const AssessmentStatusBadge: FC<{ status: ExamStatus | InspectionStatus }> = (props) => {
  const styleMapping = {
    Concept: BadgeStyle.info,
    "In uitvoering": BadgeStyle.warning,
    Afgerond: BadgeStyle.success,
    Gearchiveerd: BadgeStyle.default,
    Geen: BadgeStyle.default,
  };

  return <Badge style={styleMapping[props.status ?? "Geen"]}>{props.status ?? "Onbekend"}</Badge>;
};
